import React, { Component } from "react";
import { Icon } from "antd";
import DateSelectorComponent from './DateSelector';
import PropTypes from 'prop-types';
import { TimeFrame, ClearTime, TimeFramed } from "../../styles";
import moment from "moment";
import { oneYearBackDate, todayDate as currentDate } from "../../../../../../utils/commonUtil";
import { connect } from 'react-redux';
import { updateFilterData, replaceWithWholeData } from "../../actions";
import { CalenderClear, InfoContentWrappered } from './styles';
import { DisplayFlexOkay, InfoWrapper,QASectionWrapper, IconWrap, PopHeader, PrimaryButtonOkay } from '../../../../../TransactionSummary/Components/DateTimepicker/styles';
import { recordError } from "../../../../../../utils/commonUtil";
import { calenderState } from "../../selectors";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
 let displayDatesInitail = [oneYearBackDate(),currentDate()];
let isFilterClicked = false;
  let tempDisplayDate = [oneYearBackDate(),currentDate()]

export class Calender extends Component {
  constructor(props) {
    super(props);
    let cDate = moment();
    let bDate = moment().subtract(30, 'd');
    let todayDate = moment(cDate).format('MM/DD/YYYY');
    let beforeMonth = moment(bDate).format('MM/DD/YYYY');
    this.state = {
      visible: false,
      dates: [beforeMonth,todayDate],
      displayDates : [oneYearBackDate(),currentDate()]
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
  }
componentWillReceiveProps =(nextProps) =>{
  if(nextProps.loadMore !== this.props.loadMore)
  if(displayDatesInitail[0]===tempDisplayDate[0] && displayDatesInitail[1]===tempDisplayDate[1])
 this.setState({displayDates:[]})
}
  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = e => {
    this.setState({
      visible: false
    });
  };

  onCancel = () => {
    this.setState({ visible: false });
  }

  handleCancel = e => {
    this.setState({
      visible: false
    });
  };

  toTimeFrame = (dates) => {
    if (!dates) {
      this.setState({ dates: [] });
    }
    else {
      isFilterClicked = false;
      this.setState({ dates: dates.dateString });
    }
  }

  clearDates = () => {
    this.props.replaceWithWholeData(this.props.contributionWholeData)
    try {
      let data = null;
      let filteredData = [];
      let updatedData = this.props.contributionWholeData||[];
      let isCalculated = false;
      if (this.props.statusFilterData && this.props.statusFilterData.status) {
        let statuses = this.props.statusFilterData.status;
        statuses.map(status => {
          let filterData = [];
          filterData.push(
            updatedData.filter(data => {
              if (data.status === status) {
                return true;
              }
            })
          );
          if (filterData[0].length > 0) {
            filterData[0].map(data => filteredData.push(data));
          }
        });
        data = filteredData;
        isCalculated = true;
      } else {
        data = this.props.contributionWholeData;
      }
      this.setState({displayDates:[]});
      isFilterClicked = [];
      this.setState({ dates: [] });
      this.props.updateFilterData({ filteredData: data, mode: "timeFrameData", data: null, dates: null, isCalculated });
    } catch (error) {
      recordError(error);
    }
  }

  mobileStartDate = (date) => {
    let dates = this.state.dates ? this.state.dates : [];
    dates[0] = date;
    this.setState({ dates })
  }

  mobileEndDate = (date) => {
    let dates = this.state.dates ? this.state.dates : [];
    dates[1] = date;
    this.setState({ dates })
  }

  onFilterClick(dates) {
    try {
      let mainData = this.props.contributionWholeData || undefined;
      if (this.props.statusFilterData && this.props.statusFilterData.data?.length>0) {
        mainData = this.props.statusFilterData.data;
      }
      if (dates.length > 0) {
        tempDisplayDate[0] = JSON.parse(JSON.stringify(dates[0]));
        tempDisplayDate[1] = JSON.parse(JSON.stringify(dates[1]));
        this.setState({displayDates:tempDisplayDate})
        let filteredData = [];
        if (mainData !== undefined) {
          let updatedData = mainData;
          const date1 = moment(dates[0], "MM/DD/YYYY");
          const date2 = moment(dates[1], "MM/DD/YYYY");
       
          isFilterClicked = true;
          filteredData = updatedData.filter(x => {
            let isValid = false;
            if (x.enteredDate !== "--") {
              if (moment(x.enteredDate, "MM/DD/YYYY") >= date1 && moment(x.enteredDate, "MM/DD/YYYY") <= date2) {
                isValid = true;
              } else {
                isValid = false;
              }
              return isValid;
            }
          }
          );
          this.props.updateFilterData({ filteredData, mode: "timeFrameData", data: filteredData, dates: dates, isCalculated: false });
        }else{
          this.props.updateFilterData({ filteredData:null, mode: "timeFrameData", data: filteredData, dates: dates, isCalculated: false });
        }

      } else {
        this.props.updateFilterData({ filteredData: mainData, mode: "timeFrameData", data: null, dates: null, isCalculated: false });
      }
      this.setState({ visible: false });
    } catch (error) {
      recordError(error);
    }
  }

  render() {
    return (
      <>
        {
          this.state.displayDates && this.state.displayDates.length > 1 ?
            <TimeFramed id="dateform2">
              <span>
                <div> 
                {this.props.id? ( <> 
                <ClearTime id={"btnClearTime"+this.props.id} onClick={this.showModal}> 
                  {this.state.displayDates[0]} -  {this.state.displayDates[1]} 
                  </ClearTime>  
                  <CalenderClear id={"btnCalenderClear"+this.props.id} onClick={this.clearDates} >
                    x
                    </CalenderClear> 
                    </> 
                    ):( 
                    <> <ClearTime  onClick={this.showModal}> {this.state.displayDates[0]} -  {this.state.displayDates[1]} 
                    </ClearTime>  
                    <CalenderClear  onClick={this.clearDates} >
                      x
                      </CalenderClear> 
                      </>
                      )} 
                 </div>
              </span>
            </TimeFramed>
            :
            <TimeFrame
              id="dateform2"
              onClick={this.showModal}>
              -Select-
        </TimeFrame>
      }
        <div className={(!this.state.visible && 'hidden')}>
        <InfoWrapper>
        <InfoContentWrappered>
          <IconWrap>
            <Icon type="close" onClick={this.onCancel} id={(this.props.id)&&(this.props.id+"btnClose")}/>
          </IconWrap>
          <PopHeader>
          Pick Time Frame
          </PopHeader>
              <div>
                <QASectionWrapper>
                  <DateSelectorComponent
                    data-test="dateSelector"
                    open={this.state.visible}
                    defStartDate={this.state.defStartDate}
                    defEndData={this.state.defEndData}
                    dateValues={this.props.dateValues}
                    values={isFilterClicked ? this.state.displayDates : this.state.dates}
                    mobileEndDate={(date) => this.mobileEndDate(date)}
                    mobileStartDate={(date) => this.mobileStartDate(date)}
                    toTimeFrame={this.toTimeFrame}
                  />
                </QASectionWrapper>
                <DisplayFlexOkay>
            <GeneralButton 
            data-test="gnrl-btn"
              id={"btnFilter"}
              text = "Filter"
              width = "150px"
              mobWidth = "100%"
              onClick={() => { this.onFilterClick(this.state.dates) }}
            />
            </DisplayFlexOkay>
          </div>
        </InfoContentWrappered>
      </InfoWrapper>
      </div>
      </>
    );
  }
}

Calender.propTypes = {
  contributionData: PropTypes.array,
  statusFilterData: PropTypes.array,
  timeFrameData: PropTypes.array,
  updateFilterData: PropTypes.func
}

const mapStateToProps = (state) => ({
  ...calenderState(state.toJS())
});

export const mapDispatchToProps = (dispatch) => ({
  updateFilterData: data => dispatch(updateFilterData(data)),
  replaceWithWholeData:data => dispatch(replaceWithWholeData(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Calender);